import { useEffect, useState } from 'react';

const DEFAULT_SECONDS = 17 * 60 + 34;

export function useCountdown(totalSeconds: number = DEFAULT_SECONDS) {
  const [left, setLeft] = useState(totalSeconds);

  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft((prev) => (prev <= 1 ? totalSeconds : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [totalSeconds]);

  return {
    hours: Math.floor(left / 3600),
    minutes: Math.floor((left % 3600) / 60),
    seconds: left % 60,
  };
}
